<template>
    <div class="flex justify-start">
        <dropdown-menu>
            <div class="py-1">
                <MenuItem>
                    <Link
                        :href="route('users.edit', data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm"
                    >
                        {{ trans("users.table.actions.edit") }}
                    </Link>
                </MenuItem>

                <MenuItem>
                    <a
                        @click.prevent="deleteUser(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm"
                    >
                        {{ trans("users.table.actions.delete") }}
                    </a>
                </MenuItem>
            </div>
        </dropdown-menu>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import Swal from "sweetalert2";
import DropdownMenu from "@/Components/DropdownMenu";
import { MenuItem } from "@headlessui/vue";

export default {
    components: {
        Link,
        DropdownMenu,
        MenuItem,
    },

    props: {
        data: {
            type: Object,
        },
        index: {
            type: Number,
        },
    },

    methods: {
        deleteUser(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.trans("confirmation.delete"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(this.route("users.destroy", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },
    },
};
</script>
